export default __webpack_public_path__ + "static/media/changePassword.f17137c1.svg";